import { RootState } from 'src/ui/app/store';

export const userIdSelector = () => (state: RootState) => state.ui.userId;
